import { render, staticRenderFns } from "./DestroyForm.vue?vue&type=template&id=4c16b147&scoped=true&"
import script from "./DestroyForm.vue?vue&type=script&lang=js&"
export * from "./DestroyForm.vue?vue&type=script&lang=js&"
import style0 from "./DestroyForm.vue?vue&type=style&index=0&id=4c16b147&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c16b147",
  null
  
)

export default component.exports